/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  DAOAccessControl,
  DAOAccessControlInterface,
} from "../../../../@fractal-framework/core-contracts/contracts/DAOAccessControl";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
    ],
    name: "MissingRole",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlySelfRenounce",
    type: "error",
  },
  {
    inputs: [],
    name: "UnequalArrayLengths",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "functionDesc",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "encodedSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "string",
        name: "role",
        type: "string",
      },
    ],
    name: "ActionRoleAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "functionDesc",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "encodedSig",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "string",
        name: "role",
        type: "string",
      },
    ],
    name: "ActionRoleRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "previousAdminRole",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "adminRole",
        type: "string",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "DAO_ROLE",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OPEN_ROLE",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "sig",
        type: "bytes4",
      },
    ],
    name: "actionIsAuthorized",
    outputs: [
      {
        internalType: "bool",
        name: "isAuthorized",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "adminGrantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "adminRevokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "string[]",
        name: "functionDescs",
        type: "string[]",
      },
      {
        internalType: "string[][]",
        name: "roles",
        type: "string[][]",
      },
    ],
    name: "daoAddActionsRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string[]",
        name: "roles",
        type: "string[]",
      },
      {
        internalType: "address[][]",
        name: "members",
        type: "address[][]",
      },
    ],
    name: "daoGrantRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string[]",
        name: "roles",
        type: "string[]",
      },
      {
        internalType: "string[]",
        name: "roleAdmins",
        type: "string[]",
      },
      {
        internalType: "address[][]",
        name: "members",
        type: "address[][]",
      },
    ],
    name: "daoGrantRolesAndAdmins",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "string[]",
        name: "functionDescs",
        type: "string[]",
      },
      {
        internalType: "string[][]",
        name: "roles",
        type: "string[][]",
      },
    ],
    name: "daoRemoveActionsRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "string",
        name: "functionDesc",
        type: "string",
      },
    ],
    name: "getActionRoles",
    outputs: [
      {
        internalType: "string[]",
        name: "roles",
        type: "string[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dao",
        type: "address",
      },
      {
        internalType: "string[]",
        name: "roles",
        type: "string[]",
      },
      {
        internalType: "string[]",
        name: "roleAdmins",
        type: "string[]",
      },
      {
        internalType: "address[][]",
        name: "members",
        type: "address[][]",
      },
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "string[]",
        name: "functionDescs",
        type: "string[]",
      },
      {
        internalType: "string[][]",
        name: "actionRoles",
        type: "string[][]",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "string",
        name: "functionDesc",
        type: "string",
      },
    ],
    name: "isRoleAuthorized",
    outputs: [
      {
        internalType: "bool",
        name: "isAuthorized",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "role",
        type: "string",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "userRenounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type DAOAccessControlConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: DAOAccessControlConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class DAOAccessControl__factory extends ContractFactory {
  constructor(...args: DAOAccessControlConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DAOAccessControl> {
    return super.deploy(overrides || {}) as Promise<DAOAccessControl>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): DAOAccessControl {
    return super.attach(address) as DAOAccessControl;
  }
  override connect(signer: Signer): DAOAccessControl__factory {
    return super.connect(signer) as DAOAccessControl__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DAOAccessControlInterface {
    return new utils.Interface(_abi) as DAOAccessControlInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DAOAccessControl {
    return new Contract(address, _abi, signerOrProvider) as DAOAccessControl;
  }
}
